import React from 'react';
import {DatePicker} from 'components/antd';
import useSearchParams from '../../useSearchParams';
import moment from 'moment';
import locale from 'antd/es/date-picker/locale/ja_JP';

const TelTermFilter = () => {
  const {query, setQuery} = useSearchParams();

  return (
    <>
      <DatePicker
        placeholder="開始日"
        value={query.telFrom && moment(query.telFrom)}
        locale={locale}
        onChange={(value) => {
          setQuery({page: 1, telFrom: value?.format()});
        }}
        className="w-36"
      />
      <span className="mx-1 mt-2">~</span>
      <DatePicker
        placeholder="終了日"
        value={query.telTo && moment(query.telTo)}
        locale={locale}
        onChange={(value) => {
          setQuery({page: 1, telTo: value?.format()});
        }}
        className="w-36"
      />
    </>
  );
};

export default TelTermFilter;
